import { render, staticRenderFns } from "./ImportTrends.vue?vue&type=template&id=15acb206&scoped=true"
import script from "./ImportTrends.vue?vue&type=script&lang=js"
export * from "./ImportTrends.vue?vue&type=script&lang=js"
import style0 from "./ImportTrends.vue?vue&type=style&index=0&id=15acb206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15acb206",
  null
  
)

export default component.exports